import React, { useEffect } from "react";
import { orgActions } from "../../actions";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { IngestorDashboard } from "./IngestorDashboard";

function IngestorNav(props) {
  const { authentication, org, getScrapeInfo, parent } = props;

  const current_org_id = Number(org.current_org_id);

  const scrape_info = org.scrape_info;

  const aws_logo = require("../../images/aws_logo.png").default;
  const sharepoint_logo = require("../../images/sharepoint_logo.png").default;
  const tagtech_logo = require("../../images/icon.png").default;

  useEffect(() => {
    getScrapeInfo(current_org_id);
  }, [current_org_id]);

  return (
    <>
      <Link to={"/org/" + current_org_id + "/ingestion"} class="navLink">
        <span
          className={`leftNavElement ${
            parent === "overview" ? "bluearrow" : "mediumgreenarrow"
          }`}
        >
          ingestion log
        </span>
      </Link>
      <br />
      <Link to="/ingestion/scrape" class="navLink">
        <span
          className={`leftNavElement ${
            parent === "scrape" ? "bluearrow" : "mediumgreenarrow"
          }`}
        >
          scrape
        </span>
      </Link>
      <br />
      <Link to="/ingestion/render" class="navLink">
        <span
          className={`leftNavElement ${
            parent === "render" ? "bluearrow" : "mediumgreenarrow"
          }`}
        >
          render
        </span>
      </Link>
      <br />
      <Link to="/ingestion/dispatch" class="navLink">
        <span
          className={`leftNavElement ${
            parent === "dispatch" ? "bluearrow" : "mediumgreenarrow"
          }`}
        >
          dispatch
        </span>
      </Link>
      <br />
      <Link to="/ingestion/retrieve" class="navLink">
        <span
          className={`leftNavElement ${
            parent === "retrieve" ? "bluearrow" : "mediumgreenarrow"
          }`}
        >
          retrieve
        </span>
      </Link>
      <br />
      <Link to="/ingestion/classify" class="navLink">
        <span
          className={`leftNavElement ${
            parent === "classify" ? "bluearrow" : "mediumgreenarrow"
          }`}
        >
          classify
        </span>
      </Link>
      <br />

      <div class="fileCountsContainer">
        <span class="fileCountsImage">&nbsp;</span>
      </div>
      <div class="fileCountsContainer">
        <span class="fileCountsImage">&nbsp;</span>
      </div>

      <div class="fileCountsContainer">
        <span class="fileCountsImage">
          <img src={sharepoint_logo} width="30" />
        </span>
        <span class="fileCounts">{scrape_info?.sharepoint_file_count}</span>
      </div>

      <div class="fileCountsContainer">
        <span class="fileCountsImage">
          <img src={aws_logo} width="30" />
        </span>
        <span class="fileCounts">{scrape_info?.s3_file_count - 1}</span>
      </div>

      <div class="fileCountsContainer">
        <span class="fileCountsImage">
          <img src={tagtech_logo} width="30" />
        </span>
        <span class="fileCounts">{scrape_info?.db_file_count}</span>
      </div>
      <IngestorDashboard />
    </>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getScrapeInfo: orgActions.getScrapeInfo,
};

const connectedIngestorNav = connect(
  mapStateToProps,
  actionCreators
)(IngestorNav);
export { connectedIngestorNav as IngestorNav };
